import { z } from 'zod';

export const ReportStatusEnum = z.enum(['in_progress', 'completed', 'failed']);
export const ReportTypeEnum = z.enum([
  'Ad_Performance',
  'Performance_Mobile',
  'Ad_performance_ad_level',
]);

export const CreateReportPullLogRequestSchema = z.object({
  adAccountId: z.string(),
  connectorId: z.string(),
  type: z.array(ReportTypeEnum),
});

export const ReportPullLogItemSchema = z.object({
  id: z.string().or(z.number()),
  requestedAt: z.string(),
  completedAt: z.string().nullable(),
  executionId: z.string().nullable(),
  status: ReportStatusEnum,
  type: z.string(),
  adAccountName: z.string(),
  adAccountId: z.string(),
  schedule: z.string().optional(),
  dateRange: z.string().optional(),
});

export const ReportPullLogResponseSchema = z.object({
  data: z.object({
    items: z.array(ReportPullLogItemSchema),
  }),
});

export const ReportQueryParams = z.object({ connectionId: z.string() });
